import baseGetAllKeys from "./component-library361.mjs";
import getSymbols from "./component-library404.mjs";
import keys from "./component-library342.mjs";
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}
export {
  getAllKeys as default
};
